<style lang="less" scoped>
  .recipe-manager-cover {
    display: block;
    width: 100%;

    .recipe-manager-row {
      width: 100%;
      display: flex;
      align-items: center;
      margin-bottom: 10px;
      > strong {
        padding-right: 16px;
      }
      .recipe-manager-input {
        width: 100%;
      }
      .recipe-manager-title {
        align-self: flex-start;
        min-width: 80px;
        padding-right: 10px;
      }
      .recipe-manager-column {
        flex: 1;
      }
    }
  }

  .present-cover {
    width: 100%;
    .present-content-row {
      display: flex;
      width: 100%;
      align-items: center;
      margin-bottom: 16px;
      .present-content-column-standard {
        flex: 1;
      }
    }
    .present-add-btn-cover {
      border-bottom: 1px solid #CCC;
      padding-bottom: 16px;
    }
  }

  .present-box-cover {
    width: 100%;
    .present-box-row {
      width: 100%;
      border: 1px solid #CCC;
      display: flex;
      align-items: center;
      border-radius: 4px;
      padding: 16px;
      margin-bottom: 16px;
      &:last-child {
        margin-bottom: 0;
      }
      .present-box-column-standard {
        flex: 1;
      }
    }
  }

  .add-medicine-dialog {
    .search-cover {
      border-bottom: 1px solid #d9dde8;
    }
    .medicine-list-cover {
      .medicine-list {
        > li {
          display: flex;

          .medicine-name {
            flex: 1;
          }
        }
      }
    }
  }
</style>

<template lang="pug">
  #recipeManager.admin-container
    // 약재 선택 다이얼로그
    // el-dialog.add-medicine-dialog.custom-dialog(title="약재 선택" :visible.sync="isOpenDialog")
    //   form(method="get" action="#")
    //     .search-cover.dialog-content-cover
    //       el-input(type="text" placeholder="검색")
    //     .medicine-list-cover
    //       ul.medicine-list
    //         li.dialog-content-cover(
    //           v-for="ingredient in searchedIngredients"
    //           @click="selectIngredient(ingredient)")
    //           span.medicine-name {{ingredient.name}}
    //           span
    //             img(src="@/assets/chevron-left-small.png")
    // 약재 선택 다이얼로그
    el-dialog.add-medicine-dialog.custom-dialog(
      title="약재 선택",
      :visible.sync="dialogStatus.isOpenAddPartsDialog",
      @close='dialogClear')
      form(action='#' method='post')
        modal-present-choose-component(
          :ingredients="dialogIngredients",
          @selectIngredient="addIngredient($event)",
          @search="bindDialogIngredients($event)",
          v-if="dialogStatus.isOpenAddPartsDialog")
    form(action="#" method="get" @submit.prevent="submit")
      .admin-title-cover
        .admin-title 처방 관리 (or 수정)
      .admin-content-cover
        .recipe-manager-cover
          .recipe-manager-row
            strong.recipe-manager-title 처방명
            span.recipe-manager-column
              el-input.recipe-manager-input(type="text" v-model="name")
          .recipe-manager-row
            strong.recipe-manager-title 출처
            span.recipe-manager-column
              el-input.recipe-manager-input(type="text" v-model="source" placeholder="ex) 동의보감")
          .recipe-manager-row
            strong.recipe-manager-title 포함 약재
            .recipe-manager-column.present-cover
              .present-content-row
                .present-box-cover
                  .present-box-row(v-for="ingredient in choosedIngredient")
                    .present-box-column.present-box-column-standard
                      div
                        strong {{ingredient.name}}
                        div(style="margin-top: 5px") {{ingredient.price}} / g
                    .present-box-column
                      div
                        el-input(placeholder="그램" v-model="ingredient.cnt")
                          template(slot="append") g
              .present-content-row.present-add-btn-cover
                .present-content-column
                  el-button(@click="dialogStatus.isOpenAddPartsDialog = true") 약재 추가
                .present-content-column-standard.tr 단가 {{result}}원
          .recipe-manager-row
            strong.recipe-manager-title 첩 수
            span.recipe-manager-column
              el-input.recipe-manager-input(
                type="text",
                v-model="units")
          .recipe-manager-row.present-cover
            strong.recipe-manager-title 팩 수
            span.recipe-manager-column.present-add-btn-cover
              el-input.recipe-manager-input(
                type="text",
                v-model="packs")
          .recipe-manager-row
            .recipe-manager-title
            .present-content-row
              .present-content-column
                el-button(native-type="submit") 처방 저장
                el-button(v-if="recipeId" @click="recipeRemove") 처방 삭제
</template>

<script>
import ModalPresentChooseComponent from '@/components/modal/modal_present_choose';

export default {
  props: ['index'],
  data() {
    return {
      dialogIngredients: [], // 다이얼로그에 삽입 될 약재
      allIngredients: null, // 전체 약재
      searchedIngredients: null, // 검색 된 약재
      choosedIngredient: [], // 선택한 약재
      recipeId: null,
      isOpenDialog: false,
      // ingredients: [],
      name: null,
      source: null,
      units: 1,
      packs: 1,
      dialogStatus: {
        isOpenAddPartsDialog: false,
      },
    };
  },
  methods: {
    dialogClear() {
      this.dialogIngredients = [];
    },
    addIngredient(ingredient) {
      const obj = {};
      Object.assign(obj, ingredient);
      obj.cnt = 0;
      this.choosedIngredient.push(obj);
    },
    async bindDialogIngredients(q) {
      const query = { q: q };
      this.dialogIngredients = await this.loadIngredients(query);
    },
    getQueryString() {
      const obj = {};
      Object.assign(obj, this.$route.query);
      return obj;
    },
    async loadIngredients(query) {
      query = query || null;
      const { data } = await this.$http.get('/ingredients', { params: query });
      return data;
    },
    async submit() {
      const ingredient = [];
      this.choosedIngredient.forEach((element) => {
        ingredient.push({
          ingredient: element._id,
          amount: element.cnt,
        });
      });
      const payload = {
        name: this.name,
        ingredients: ingredient,
        source: this.source,
        units: this.units * 1,
        packs: this.packs * 1,
      };

      let error = null;
      this.choosedIngredient.forEach((obj) => {
        const cnt = obj.cnt;
        if (cnt <= 0) {
          error = '약재의 함량을 확인해주세요.';
          return false;
        }
      });

      if (error) {
        alert(error);
        return false;
      }

      if (!this.recipeId) {
        await this.$http.post('/prescriptions', payload);
        alert('처방 등록에 성공했습니다!');
      } else {
        await this.$http.put('/prescriptions/'.concat(this.recipeId), payload);
        alert('처방 수정을 완료했습니다!');
      }
      this.$router.push('/admin/recipe');
    },
    async recipeRemove() {
      try {
        await this.$http.delete('/prescriptions/'.concat(this.recipeId));
        alert('처방이 삭제되었습니다.');
        this.$router.push('/admin/recipe');
      } catch (e) {
        console.log(e);
      }
    },
    selectIngredient(item) {
      item.cnt = 1;
      this.choosedIngredient.push(item);
    },
  },
  computed: {
    result() {
      let result = 0;
      this.choosedIngredient.forEach((element) => {
        result += element.price * element.cnt;
      });
      return result;
    },
  },
  async mounted() {
    this.recipeId = this.$route.params.recipeId || false;

    // 약재 정보 로드
    try {
      const { data } = await this.$http.get('/ingredients');
      this.allIngredients = data;
      this.searchedIngredients = data;
    } catch (e) {
      alert('약재를 불러오지 못했습니다!');
    }
    // 기존 정보 로드
    if (this.recipeId) {
      try {
        const prescriptionData = await this.$http.get('/prescriptions/'.concat(this.recipeId));
        prescriptionData.data.ingredients.forEach(async (element) => {
          const ingredientData = await this.$http.get('/ingredients/'.concat(element.ingredient));
          ingredientData.data.cnt = element.amount;
          this.choosedIngredient.push(ingredientData.data);
        });
        this.name = prescriptionData.data.name;
        this.source = prescriptionData.data.source;
        this.units = prescriptionData.data.units;
        this.packs = prescriptionData.data.packs;
      } catch (e) {
        alert('데이터 로드에 실패했습니다!');
      }
    }
  },
  components: {
    ModalPresentChooseComponent,
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/admin/recipe_manager.vue